import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext({});

const lireUser = () => {
  try {
    const stored = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    return stored && token ? JSON.parse(stored) : null;
  } catch { return null; }
};

const enregistrer = (data) => {
  localStorage.setItem('token', data.token);
  localStorage.setItem('user', JSON.stringify(data.user));
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Retour de Google OAuth : le token arrive dans l'URL
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      window.history.replaceState({}, '', '/dashboard');
      api.me().then(data => {
        if (data && !data.error) {
          localStorage.setItem('user', JSON.stringify(data));
          setUser(data);
        }
        setLoading(false);
      });
      return;
    }
    setUser(lireUser());
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await api.login(email, password);
    if (data.error) throw new Error(data.error);
    enregistrer(data);
    setUser(data.user);
    return data;
  }, []);

  const register = useCallback(async (nom, email, password) => {
    const data = await api.register(nom, email, password);
    if (data.error) throw new Error(data.error);
    enregistrer(data);
    setUser(data.user);
    return data;
  }, []);

  const loginWithOTP = useCallback(async (email, otp) => {
    const data = await api.verifyOTP(email, otp);
    if (data.error) throw new Error(data.error);
    enregistrer(data);
    setUser(data.user);
    return data;
  }, []);

  const loginWithGoogle = useCallback(() => api.googleLogin(), []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, register, loginWithOTP, loginWithGoogle, logout }),
    [user, loading, login, register, loginWithOTP, loginWithGoogle, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
